module.exports = __webpack_public_path__ + "static/ceremony-c6c8fe1c8db9be0706ab5502f5fa1d4e.jpg";